import React, {Component} from 'react';
import { Popover } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';

import formatTextWrap from '../utils/formatTextWrap';

class CompliancePopover extends Component {

    resultCodes = { "SUCCESS": 0, "WARNING": 1, "FAILURE": 2, "ERROR": 3 };

    render() {
        // Create copies that can be edited
        let compliance = (this.props.compliance) ? JSON.parse(JSON.stringify(this.props.compliance)) : [];
		let resultType = this.props.resultsType;
		let assetType = this.props.assetType;

        let issuesCount = 0;

        for (let i = 0; i < compliance.length; i++) {
            if (compliance[i].result === "FAILURE" || compliance[i].result === "ERROR") {
				if (resultType === "WARNING")
					compliance[i].result = "WARNING";
                issuesCount++;
            }
            if (compliance[i].message === null) compliance[i].message = "";
        }

        compliance.sort((a,b) => {
            if (this.resultCodes[a.result] < this.resultCodes[b.result])
                return 1;
            if (this.resultCodes[a.result] > this.resultCodes[b.result])
                return -1;
            return 0;
        });

        const headerStyle = {
            backgroundColor: '#f0f0f0'
        };
        const columns = [
            {
                dataField: 'rule',
                text: 'Rule',
                headerStyle: headerStyle,
                style: {
                    fontWeight: 'bold'
                }
            },
            {
                dataField: 'result',
                text: 'Result',
                headerStyle: headerStyle,
                style: (cell, row, rowIndex, colIndex) => {
                    switch (cell) {
                        case "SUCCESS":
                            return { color: 'green' };
                        case "FAILURE":
                        case "ERROR":
                            return { color: 'red' };
                        case "WARNING":
                            return { color: 'orange' };
                        default:
                            return { color: 'black' };
                    }
                }
            },
            {
              dataField: 'message',
              text: 'Message',
              headerStyle: headerStyle
            }
        ];

        return (
          <Popover id="popover-basic" title="Compliance">
              <div>
                <h3 style={{ display: 'inline'}}>{this.props.asset}</h3>
                <h5 style={{ display: 'inline'}}>
                    <span style={{ color: '#777' }}>&emsp;Archive: </span> <span>{this.props.archive}</span>
                    <span style={{ color: '#777' }}>&emsp;Engine: </span> <span>{this.props.engine}</span>
                    <span style={{ color: '#777' }}>&emsp;Project: </span> <span>{this.props.project}</span>
                </h5>
                <h4 style={{ color: '#777' }}>
					{
						(resultType === "WARNING") ?
							<div>Warnings: <span style={{ color: 'orange' }}>{issuesCount}</span> of {compliance.length} {assetType} rules</div>
							:
				            <div>Blockers: <span style={{ color: 'red' }}>{issuesCount}</span> of {compliance.length} {assetType} rules</div>
					}
                </h4>
              </div>
              <BootstrapTable
                    keyField='rule'
                    data={
                        compliance.filter(test => {
							return test.result != "SUCCESS"
						}).map(test => {
                            return {
                                rule: test.rule,
                                result: test.result,
                                message: formatTextWrap(test.message, 80)
                            };
                        })
                    }
                    columns={ columns }
              />
          </Popover>
        );
    }
};

export default CompliancePopover;


